import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { DatePickerFigo } from '../../../common';

import './DateInput.css';

const DateInput = ({
  useMarginLeft = true,
  maxDate = '',
  minDate = '',
  onSelectedValidDate = () => { },
  selectedDate = '',
  title = '',
}) => {
  const { t } = useTranslation('fileClaimbot');

  const onDatePickerChange = (date) => {
    // just for comparing dates, not for displaying
    const dateFormatted = moment(date).format('YYYY-MM-DD');
    const inRange = dateFormatted >= minDate && dateFormatted <= maxDate;
    onSelectedValidDate({ date, inRange });
  };

  return (
    <div
      className="File-claim-date-input-container"
      data-margin-left={useMarginLeft}
    >
      <span>{title || t('dateOfClaim')}</span>

      <DatePickerFigo
        maxDate={maxDate}
        minDate={minDate}
        onDateChange={onDatePickerChange}
        selectedDate={selectedDate}
      />
    </div>
  );
};

export { DateInput };
